import { k as jsxRuntimeExports } from "./doenetml-drNYjJiF.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-CDZbHBy-.js";
import { r as renderMarkupBody } from "./markupRenderer-rPpSzHPv.js";
const sq = React__default.memo(function Sq(props) {
  const { SVs, children } = useDoenetRenderer(props);
  const body = renderMarkupBody({ SVs, children });
  if (body === null) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    "‘",
    body,
    "’"
  ] });
});
export {
  sq as default
};
